import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { FormControl, themeGet } from '@primer/react';

var LTFormControl = function LTFormControl(_a) {
  var _b = _a.caption,
    caption = _b === void 0 ? "" : _b,
    _c = _a.captionStyle,
    captionStyle = _c === void 0 ? {} : _c,
    _d = _a.children,
    children = _d === void 0 ? null : _d,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = _a.formStyles,
    formStyles = _f === void 0 ? {} : _f,
    _g = _a.id,
    id = _g === void 0 ? "" : _g,
    _h = _a.isRequired,
    isRequired = _h === void 0 ? false : _h,
    _j = _a.label,
    label = _j === void 0 ? "" : _j,
    _k = _a.labelAs,
    labelAs = _k === void 0 ? "label" : _k,
    // Default value adjusted for TypeScript
    _l = _a.labelStyle,
    // Default value adjusted for TypeScript
    labelStyle = _l === void 0 ? {} : _l,
    _m = _a.leadingVisual,
    leadingVisual = _m === void 0 ? null : _m,
    _o = _a.leadingVisualStyle,
    leadingVisualStyle = _o === void 0 ? {} : _o,
    _p = _a.validationArr,
    validationArr = _p === void 0 ? [] : _p,
    _q = _a.validationStyles,
    validationStyles = _q === void 0 ? {} : _q;
  return /*#__PURE__*/React.createElement(FormControl, {
    disabled: disabled,
    id: id,
    required: isRequired,
    sx: formStyles
  }, label && /*#__PURE__*/React.createElement(FormControl.Label, {
    as: labelAs,
    htmlFor: id,
    sx: labelStyle
  }, label), leadingVisual && /*#__PURE__*/React.createElement(FormControl.LeadingVisual, {
    sx: leadingVisualStyle
  }, leadingVisual), children, validationArr.map(function (validation, index) {
    var _a = validation || {},
      _b = _a.variant,
      variant = _b === void 0 ? LTFormControl.ValidationVariant.SUCCESS : _b,
      _c = _a.validationCheck,
      validationCheck = _c === void 0 ? false : _c,
      _d = _a.message,
      message = _d === void 0 ? "" : _d;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, validationCheck && /*#__PURE__*/React.createElement(FormControl.Validation, {
      sx: __assign({
        marginTop: themeGet("space.1")
      }, validationStyles),
      variant: variant
    }, message));
  }), caption && /*#__PURE__*/React.createElement(FormControl.Caption, {
    sx: captionStyle
  }, caption));
};
// Define static properties for labelAs and validationVariant
LTFormControl.LabelAs = {
  LABEL: "label",
  LEGEND: "legend",
  SPAN: "span"
};
LTFormControl.ValidationVariant = {
  ERROR: "error",
  SUCCESS: "success"
};

export { LTFormControl as default };
